import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const LeadsTeamLayout = () => {
const navList = useNav();
  let { LeadsTeamBottomHeader, LeadsTopHeader } = navList;
    
    return (
        <div className="webBody">
            <Header bottomTabs={LeadsTeamBottomHeader} topTabs={LeadsTopHeader} />
            <Outlet />
        </div>
    )
}

export default LeadsTeamLayout;